import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { StylesIndexInjections } from 'common-react';
import { interactiveLinkStyle, pressedLinkShadow } from '../../theme/constants';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      paddingBottom: 16,
      margin: '0 0 16px',
      borderBottom: `1px solid ${theme.color.greys[15]}`,
    },
  },

  oldFundName: {
    marginTop: 4,
  },

  infoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      '& $infoBox:nth-child(1), & $infoBox:nth-child(4)': {
        paddingRight: 8,
      },
      '& $infoBox:last-child': {
        flexBasis: '100%',
        width: '100%',
      },
    },
  },

  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
      width: '50%',
    },
  },

  buttonBox: {
    marginLeft: 28,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: 16,
    },
  },

  actionBox: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down(theme.breakpoints.values.sl)]: {
      flexDirection: 'column',
    },

    [theme.breakpoints.down('sm')]: {
      alignSelf: 'stretch',
    },

    '&:not(:empty)': {
      [theme.breakpoints.down('sm')]: {
        borderTop: `1px solid ${theme.color.greys[10]}`,
      },
    },
  },

  potentialProfitWrapper: {
    display: 'flex',
    gap: 56,
    paddingTop: 24,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      paddingTop: 16,
      gap: 16,
    },
  },

  potentialProfitDesc: {
    flex: 1,
  },

  potentialProfitBenefits: {
    width: 290,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  button: {
    '&:hover': {
      cursor: 'pointer',
      '& $text': {
        ...interactiveLinkStyle(theme),
      },
      '& $icon path': {
        fill: theme.color.violets[100],
      },
    },
    '&:active': {
      '& $textWrapper': {
        backgroundColor: pressedLinkShadow  ,
      },
    },
  },
  textWrapper: {},
  text: {},
  icon: {},
}), { name: 'FundListItemWithPotentialProfit', index: StylesIndexInjections.UI_MOLECULES });
